import axiosClient from "./axiosClient";

const endpoint = "/commerce/order-fulfilment-policy";

export const orderFulfilmentPolicyApi = {
  async get() {
    const response = await axiosClient.get(endpoint, { __silentGenericToast: true });
    return response.data;
  },
  async listCheckoutFlows() {
    const response = await axiosClient.get(`${endpoint}/checkout-flows`, {
      __silentGenericToast: true,
    });
    return response.data;
  },
  async update(policy) {
    const response = await axiosClient.put(
      endpoint,
      {
        mode: policy.mode,
        requireCheckoutReadyBeforeAcceptance:
          policy.requireCheckoutReadyBeforeAcceptance,
        checkoutFlowDefinitionId: policy.checkoutFlowDefinitionId || null,
      },
      { __silentGenericToast: true },
    );
    return response.data;
  },
};
